import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * State and actions
 */

type State = PaginationProperties;

type Action = SetPaginationProperties;

/**
 * useGestaoTreinamentosCadastroPagination
 */

export const useGestaoTreinamentosCadastroPagination = create<State & Action>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));